<div class="risk-group-view-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <button
      (click)="modify()"
      [disabled]="!(userPermissions | async).settlement.write"
      mat-stroked-button color="primary"
    >
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngFor="let group of riskConfiguration.groups">
    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <h3>Grupa</h3>
      <div fxLayout="row">
        <app-detail fxFlex="100" header="Kody grupy">
          <mat-chip-list>
            <ng-container *ngFor="let riskgroupName of group.groupNames;">
              <mat-chip color="accent" selected>{{ riskgroupName.groupName }}</mat-chip>
            </ng-container>
          </mat-chip-list>
        </app-detail>
      </div>

      <h4>Ryzyka</h4>

      <ng-container *ngFor="let risk of group.risks; index as i">
        <div fxFlex="100" fxLayout="column" fxLayoutGap="15px" class="risk-record-container mat-elevation-z2">
          <div fxFlex="100" fxLayout="column" fxLayoutGap="15px"
               [ngClass]="{'riskNameSelect': risk.name == this.initialFiltersRisk}">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="25px" class="list-counter">
                <div>{{ i + 1 }}.</div>
              </div>
              <app-detail fxFlex header="Kod ryzyka" [value]="risk.name"></app-detail>
              <app-detail fxFlex header="Nazwa ryzyka" [value]="risk.riskName"></app-detail>
              <app-detail fxFlex header="Riders" [value]="risk.riders"></app-detail>
              <app-detail fxFlex header="Typ polisy" [value]="risk.policyType?.name"></app-detail>
            </div>
          </div>
          <div fxFlex="100" fxLayout="column" fxLayoutGap="15px"
               [ngClass]="{'riskNameSelect': risk.name == this.initialFiltersRisk}">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="25px" class="list-counter">
                <div></div>
              </div>
              <app-detail fxFlex header="Stawki % TU">
                <mat-chip-list>
                  <ng-container *ngFor="let rate of risk.ratesArray;">
                    <mat-chip color="accent" selected>{{ rate }}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>

              <app-detail
                fxFlex
                header="Stawka % Partner LEGACY"
              >
                <mat-chip-list *ngIf="risk.ratePaid">
                  <mat-chip
                    class="green-mat-chip"
                    selected
                    matTooltip="Stara stawka bazowa - pole Risk.ratePaid"
                  >
                    {{ risk.ratePaid }}
                  </mat-chip>
                </mat-chip-list>
              </app-detail>
              <ng-container
                *ngFor="let commissionTable of commissionTables"
              >
                <app-detail
                  fxFlex
                  [header]="commissionTable.shortName"
                >
                  <mat-chip-list
                    *ngIf="getCommissionRatePaid(risk, commissionTable.uuid) !== null" >
                    <mat-chip
                      class="green-mat-chip"
                      selected
                      [matTooltip]="commissionTable.name"
                    >
                      {{getCommissionRatePaid(risk, commissionTable.uuid) }}
                    </mat-chip>
                  </mat-chip-list>

                  <span *ngIf="getCommissionRatePaid(risk,commissionTable.uuid ) === null "> - </span>
                </app-detail>
              </ng-container>

            </div>

            <ng-container *ngFor="let riskRate of getRiskRates(risk, TYPE_PARTNERS); index as i">
              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <div fxFlex></div>

                <div fxFlex="55px" class="list-counter">
                  <span>Aneks {{ i + 1 }}.</span>
                </div>

                <app-detail fxFlex="50" fxFlex.lt-md="66" header="Partnerzy">
                  <mat-chip-list>
                    <ng-container *ngFor="let partner of riskRate.partners;">
                      <mat-chip
                        color="accent" selected
                        [matTooltip]="'ID: ' + partner.recordId + ', NIP: ' + partner.nip + ', REGON: ' + partner.regon"
                        matTooltipPosition="above"
                      >{{ partner.shortName }}
                      </mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>

                <app-detail fxFlex header="Stawka % Partner">
                  <mat-chip-list *ngIf="riskRate.ratePaid !== null">
                    <mat-chip class="green-mat-chip" selected>{{ riskRate.ratePaid }}</mat-chip>
                  </mat-chip-list>
                </app-detail>

              </div>
            </ng-container>

            <ng-container *ngFor="let riskRate of getRiskRates(risk, TYPE_THRESHOLD); index as i">
              <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around end">
                <div fxFlex></div>

                <div fxFlex="55px" class="list-counter">
                  <span>Próg {{ i + 1 }}.</span>
                </div>

                <div fxFlex="50" fxFlex.lt-md="66" fxLayoutGap="15px">
                  <app-detail fxFlex="50" header="Suma od">
                    <mat-chip-list *ngIf="riskRate.thresholdFrom !== null">
                      <mat-chip color="accent" selected>{{ riskRate.thresholdFrom }}</mat-chip>
                    </mat-chip-list>
                  </app-detail>

                  <app-detail fxFlex="50" header="Suma do">
                    <mat-chip-list *ngIf="riskRate.thresholdTo !== null">
                      <mat-chip color="accent" selected>{{ riskRate.thresholdTo }}</mat-chip>
                    </mat-chip-list>
                  </app-detail>
                </div>

                <app-detail fxFlex header="Stawka % Partner">
                  <mat-chip-list *ngIf="riskRate.ratePaid !== null">
                    <mat-chip class="green-mat-chip" selected>{{ riskRate.ratePaid }}</mat-chip>
                  </mat-chip-list>
                </app-detail>

              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

    </mat-card>
  </div>

</div>
